import type { IconData } from '@stacksjs/iconify-core'

export const contentCopy: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M0 12V0h12v2.5H2.5V12z\"/><path fill=\"currentColor\" d=\"M16 4H4v12h12z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default contentCopy
